import apiClient from 'services/api';

export const requestSubscribeOtp = (phone_number: string) =>
  apiClient.post<{ first_name: string; last_name: string }>(
    '/public/subscribe/request-otp',
    { phone_number },
  );

export const verifySubscribeOtp = (phone_number: string, otp_code: string) =>
  apiClient.post<{ first_name: string; last_name: string }>(
    '/public/subscribe/verify-otp',
    { phone_number, otp_code },
  );

export const initiateSubscription = (phone_number: string, months: number) =>
  apiClient.post<{ payment_url: string }>('/public/subscribe/initiate', {
    phone_number,
    months,
  });
